/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2024, Zumper
 * @description Get similar listings for the multi-message modal
 */

import { localStorageSingleton } from '@zcode/nr-utils'
import * as MessageC from '@zcode/nr/es/shared/constants/message'
import { filterSimilarListings } from '@zcode/nr/es/shared/utils/filterSimilarListings'
import type { Dispatch, FiltersState, GetState, Listable, Property } from '@zcode/state-type'
import * as Inspectors from '../../inspectors/index'
import { logger } from '../../logger'
import { getBackFilledSimilarListings } from '../../utils/getBackFilledSimilarListings'

export const getMMListables =
  ({ entity, filters }: { entity: Listable | Property; filters: FiltersState }) =>
  async (_: Dispatch, getState: GetState) => {
    try {
      const state = getState()
      const similar = await getBackFilledSimilarListings({
        checkIsFavorited: Inspectors.checkIsFavorited(state),
        checkIsMessaged: Inspectors.checkIsMessaged(state),
        entity,
        favorited: Inspectors.getFavorited(state),
        filters,
        forMultiMessage: true,
        messaged: Inspectors.getMessaged(state),
      })
      const includeIncomeRestricted = localStorageSingleton.get('messagedIncomeRestricted')
      const filteredSimilarListings = filterSimilarListings({
        similar,
        displayLimit: MessageC.MULTI_MSG_DISPLAY_LIMIT,
        includeIncomeRestricted,
      })
      return filteredSimilarListings
    } catch (e: unknown) {
      const args =
        e instanceof Error
          ? [e]
          : [new Error('Failed to fetch similar listings for multi-message modal'), e]
      logger.error(...args)
      return null
    }
  }
